// UI components initialization and references

export const ui = {
  searchInput: document.getElementById("searchInput"),
  tagFilter: document.getElementById("tagFilter"),
  categoryFilter: document.getElementById("categoryFilter"),
  showDeletedToggle: document.getElementById("showDeletedToggle"),
  syncFromBtn: document.getElementById("syncFromBtn"),
  syncToBtn: document.getElementById("syncToBtn"),
  newNoteBtn: document.getElementById("newNoteBtn"),
  newFolderBtn: document.getElementById("newFolderBtn"),
  settingsBtn: document.getElementById("settingsBtn"),
  folderTree: document.getElementById("folderTree"),
  noteList: document.getElementById("noteList"),
  breadcrumb: document.getElementById("breadcrumb"),
  currentFile: document.getElementById("currentFile"),
  editor: document.getElementById("editor"),
  syncStatusIcon: document.getElementById("syncStatusIcon"),
  softDeleteBtn: document.getElementById("softDeleteBtn"),
  hardDeleteBtn: document.getElementById("hardDeleteBtn"),
  restoreBtn: document.getElementById("restoreBtn"),
  boldBtn: document.getElementById("boldBtn"),
  italicBtn: document.getElementById("italicBtn"),
  underlineBtn: document.getElementById("underlineBtn"),
  strikeBtn: document.getElementById("strikeBtn"),
  highlightBtn: document.getElementById("highlightBtn"),
  headingBtn: document.getElementById("headingBtn"),
  bulletBtn: document.getElementById("bulletBtn"),
  checkboxBtn: document.getElementById("checkboxBtn"),
  codeBtn: document.getElementById("codeBtn"),
  quoteBtn: document.getElementById("quoteBtn"),
  settingsDialog: document.getElementById("settingsDialog"),
  currentAdapterDisplay: document.getElementById("currentAdapterDisplay"),
  logoutBtn: document.getElementById("logoutBtn"),
  exportZipBtn: document.getElementById("exportZipBtn"),
  extensionsList: document.getElementById("extensionsList"),
  themeSelect: document.getElementById("themeSelect"),
  extensionFile: document.getElementById("extensionFile"),
  extensionUrl: document.getElementById("extensionUrl"),
  addExtensionUrl: document.getElementById("addExtensionUrl"),
  checkExtensionUpdates: document.getElementById("checkExtensionUpdates"),
  themeFile: document.getElementById("themeFile"),
  themeUrl: document.getElementById("themeUrl"),
  addThemeUrl: document.getElementById("addThemeUrl"),
  banner: document.getElementById("banner"),
  viewToggleBtn: document.getElementById("viewToggleBtn"),
  closeEditorBtn: document.getElementById("closeEditorBtn"),
  moreActionsBtn: document.getElementById("moreActionsBtn"),
  listBackBtn: document.getElementById("listBackBtn"),
  editorBackBtn: document.getElementById("editorBackBtn"),
  noteTitleInput: document.getElementById("noteTitleInput"),
  welcomeDialog: document.getElementById("welcomeDialog"),
  welcomeContentMain: document.getElementById("welcomeContentMain"),
  welcomeLoading: document.getElementById("welcomeLoading"),
  welcomeLoadingTitle: document.getElementById("welcomeLoadingTitle"),
  welcomeLoadingMessage: document.getElementById("welcomeLoadingMessage"),
  welcomeProgressText: document.getElementById("welcomeProgressText"),
  welcomeDropboxBtn: document.getElementById("welcomeDropboxBtn"),
  welcomeOneDriveBtn: document.getElementById("welcomeOneDriveBtn"),
  welcomeGoogleDriveBtn: document.getElementById("welcomeGoogleDriveBtn"),
  welcomeWebDAVBtn: document.getElementById("welcomeWebDAVBtn"),
  welcomeGitHubBtn: document.getElementById("welcomeGitHubBtn"),
  welcomeGitLabBtn: document.getElementById("welcomeGitLabBtn"),
  welcomeSelfHostedGitBtn: document.getElementById("welcomeSelfHostedGitBtn"),
  welcomeS3Btn: document.getElementById("welcomeS3Btn"),
  welcomeDemoBtn: document.getElementById("welcomeDemoBtn"),
  welcomeDecideLaterBtn: document.getElementById("welcomeDecideLaterBtn"),
  noteTagsInput: document.getElementById("noteTagsInput"),
  noteCategoriesInput: document.getElementById("noteCategoriesInput"),
  noteDueDateInput: document.getElementById("noteDueDateInput"),
  noteStarBtn: document.getElementById("noteStarBtn"),
  noteColorBtn: document.getElementById("noteColorBtn"),
  noteColorInput: document.getElementById("noteColorInput"),
  metadataBtn: document.getElementById("metadataBtn")
};
